import React, {Suspense} from 'react';
import {Route, RouteProps} from 'react-router-dom';
import PageLoading from "../components/loading";

export type DefaultRouteProps = {
    component: React.ComponentType<any>;
    layout: React.ComponentType<any>;
    theme?: any;
} & RouteProps;

function DefaultRoute(props: DefaultRouteProps) {
    const {component: Component, layout: Layout, ...rest} = props;
    return (
        <Suspense fallback={<PageLoading/>}>
            <Route {...rest}
                   render={routeProps => (
                       <Layout>
                           <Component {...routeProps} />
                       </Layout>
                   )}
            />
        </Suspense>
    );
}

export default DefaultRoute;